import { SUPPORT_SHOWN_SESSION_PREFIX } from "./constants"
import { SupportSurface } from "./tracking"

/**
 * `Support Widget Shown` fires at most once per surface per session (tracking plan).
 * Returns whether this call is the first for `surface`. PostHog's own dedup only
 * compares with the last bag, so it does not survive a reload or a visit to another
 * surface — this guard does.
 */
export const markSupportShownOnce = (surface: SupportSurface): boolean => {
  const key = `${SUPPORT_SHOWN_SESSION_PREFIX}${surface}`

  try {
    if (window.sessionStorage.getItem(key) === "1") {
      return false
    }
    window.sessionStorage.setItem(key, "1")
  } catch {
    // Storage unavailable (private mode): report rather than lose the impression.
  }

  return true
}
